import { render } from "./JourneyCard.vue?vue&type=template&id=4f7aa0c0"
import script from "./JourneyCard.vue?vue&type=script&lang=js"
export * from "./JourneyCard.vue?vue&type=script&lang=js"

import "./JourneyCard.vue?vue&type=style&index=0&id=4f7aa0c0&lang=scss"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__